import { CaseType } from "@teamprevent/common/model";

export enum ManageAssignedUsersPaths  {
    ManageAssignedUsersRoute = "manageAssignedUsers"
}

export const manageAssignedUsersRoutes = {
    "/manageAssignedUsers": {
        title: "Manage Assigned Users",
        requiredProducts: [CaseType.REFERRAL]
    }
};
